import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const agentWorkTime: TComputedPropMapper<string | undefined> = ({ offer: { user } }) => {
  return user?.agentAvailability?.title || undefined;
};
